import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { hostelResolver } from '@app/hostel.resolver';
import {HostelPageComponent} from "@app/hostel/hostel-page.component";
import { HostelRoomsComponent } from './hostel-rooms/hostel-rooms.component';
import { DefaultQueryParamsGuard } from './default-params.guard';

const routes: Routes = [
  {
    path: '',
    data: {
      showFooter: true,
      showMobileHeader: false
    },
    children: [
      {
        path: ':id',
        component: HostelPageComponent,
        canActivate: [DefaultQueryParamsGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        // runGuardsAndResolvers: 'paramsChange',
        resolve: {
          hostel: hostelResolver
        },
        data: {
          showMobileHeader: false,
          showFooter: true,
          name: 'hostel',
          title: '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Hostel Hop',
          metaTags: {
            name: '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',

            title: '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Hostel Hop',
            'og:title': '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',
            'twitter:title': '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',

            'og:image': "[[SSR_DATA_HOSTEL_OG_IMAGE]]",
            'twitter:image': "[[SSR_DATA_HOSTEL_OG_IMAGE]]",

            description: "[[SSR_DATA_DESCRIPTION]]",
            'og:description': '[[SSR_DATA_DESCRIPTION]]',
            'twitter:description': '[[SSR_DATA_DESCRIPTION]]',
            'twitter:card': '[[SSR_DATA_DESCRIPTION]]',

            'og:type': 'website',
          }
        }
      },
      {
        path: ':id/rooms',
        component: HostelRoomsComponent,
        canActivate: [DefaultQueryParamsGuard],
        resolve: {
          hostel: hostelResolver
        },
        data: {
          showMobileHeader: false,
          showFooter: false,
          name: 'hostel',
          title: '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',
          metaTags: {
            name: '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',

            title: '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',
            'og:title': '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',
            'twitter:title': '[[SSR_DATA_HOSTEL_NAME]] in [[SSR_DATA_CITY_NAME]], [[SSR_DATA_COUNTRY_OR_US_STATE_NAME]] - Discover the best hostels worldwide - Hostel Hop',

            'og:image': "[[SSR_DATA_HOSTEL_OG_IMAGE]]",
            'twitter:image': "[[SSR_DATA_HOSTEL_OG_IMAGE]]",

            description: "[[SSR_DATA_DESCRIPTION]]",
            'og:description': '[[SSR_DATA_DESCRIPTION]]',
            'twitter:description': '[[SSR_DATA_DESCRIPTION]]',

            'og:type': 'website',
          }
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HostelPageRoutingModule { }
